import gql from 'graphql-tag';

export default gql`
  mutation AddMeal($input: DailyTrackerAddMealInputType!) {
    dailyTracker {
      addMeal(input: $input) {
        ... on DailyTrackerAddMealSuccess {
          meal {
            id
          }
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on UnauthorizedException {
          code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
